import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import {Label} from '@primer/react'
import React from 'react'

type Props = {
  label: string
  ariaLabel: string
  testId: string
  viewerDidAuthor?: boolean
}

export const CommentHeaderBadge: React.FC<Props> = ({label, ariaLabel, testId, viewerDidAuthor}: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const [buttonContentProps, buttonTooltipElement] = usePortalTooltip({
    contentRef,
    'aria-label': ariaLabel,
  })

  return (
    <Label
      variant="secondary"
      data-testid={testId}
      aria-label={ariaLabel}
      ref={contentRef}
      sx={viewerDidAuthor ? {borderColor: 'accent.muted'} : {}}
      {...buttonContentProps}
    >
      {label}
      {buttonTooltipElement}
    </Label>
  )
}

try{ CommentHeaderBadge.displayName ||= 'CommentHeaderBadge' } catch {}